<template>
	<div>
		<div class="row">
			<!-- DATE -->
			<div class="col-md-3">
				<div class="form-group">
					<label>Fecha</label>
					<input id="daterange" type="text" class="form-control daterange"/>
				</div>
			</div>

			<!-- PROJECTS -->
			<template v-if="dataFilter.report_type != 'projects'">
				<div v-if="projects" class="col-md-3">
					<div v-if="projects.length" class="form-group">
						<label>Proyectos</label>
						<select @change="projectIsSelected" v-model="projectSelected" class="form-control">
							<option :value="null">Seleccionar proyecto...</option>
							<option v-for="project in projects" :value="project">{{project.name}}</option>
						</select>
					</div>
				</div>
			</template>

			<!-- REPORTS TYPE -->
			<div class="col-md-3">
				<div class="form-group">
					<label>Reporte de:</label>
					<select @change="reportTypeSelected()" v-model="dataFilter.report_type" class="form-control">
						<option value="tasks">Tareas</option>
						<option value="projects">Proyectos</option>
						<option value="closing_users">Cierres de personal</option>
						<option value="closing_customers">Cierres de clientes</option>
					</select>
				</div>
			</div>

			<!-- TASKS STATUS -->
			<div v-if="dataFilter.report_type == 'tasks'">
				<div v-if="tasks_statuses">
					<div v-if="tasks_statuses.length" class="col-md-3">
						<div class="form-group">
							<label>Estados</label>
							<select v-model="dataFilter.task_status_id" class="form-control">
								<option :value="null">Seleccionar estado...</option>
								<option v-for="statuse in tasks_statuses" :value="statuse.id">{{statuse.name}}</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<!-- PROJECTS STATUS -->
			<div v-if="dataFilter.report_type == 'projects'">
				<div v-if="projects_statuses">
					<div v-if="projects_statuses.length" class="col-md-3">
						<div class="form-group">
							<label>Estados</label>
							<select v-model="dataFilter.project_status_id" class="form-control">
								<option :value="null">Seleccionar estado...</option>
								<option v-for="statuse in projects_statuses" :value="statuse.id">{{statuse.name}}</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<!-- places -->
			<div v-if="dataFilter.report_type != 'projects'">
				<div v-if="places">
					<div v-if="places.length" class="col-md-3">
						<div class="form-group">
							<label>Localizaciones</label>
							<select v-model="dataFilter.place_id" class="form-control">
								<option :value="null">Seleccionar localización</option>
								<option v-for="place in places" :value="place.id">{{place.name}}</option>
							</select>
						</div>
					</div>
				</div>
			</div>

			<!-- CUSTOMERS -->
			<div v-if="projectSelected" class="col-md-3">
				<div v-if="projectSelected.customers.length" class="form-group">
					<label>Clientes</label>
					<select @change="customerIsSelected" v-model="customerSelected" class="form-control">
						<option :value="null">Seleccionar cliente...</option>
						<option v-for="customer in projectSelected.customers" :value="customer">{{customer.name}}</option>
					</select>
				</div>
			</div>
		</div>

		<div class="row" v-if="dataFilter.report_type != 'projects'">
			<!-- DEPARTMENTS -->
			<div v-if="departments" class="col-md-3">
				<div v-if="departments.length" class="form-group">
					<label>Departamentos</label>
					<select @change="departmentIsSelected" v-model="departmentSelected" class="form-control">
						<option :value="null">Seleccionar departamento...</option>
						<option v-for="department in departments" :value="department">{{department.name}}</option>
					</select>
				</div>
			</div>

			<!-- USERS -->
			<div v-if="departmentSelected" class="col-md-3">
				<div v-if="departmentSelected.users">
					<div v-if="departmentSelected.users.length" class="form-group">
						<label>Personal</label>
						<select v-model="dataFilter.user_id" class="form-control">
							<option :value="null">Seleccionar personal...</option>
							<option v-for="user in departmentSelected.users" :value="user.id">
								{{user.profile.first_name}} {{user.profile.last_name}}
							</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'dataFilter'],
		components: {
		},
		data () {
			return {
				departmentSelected: null,
				projectSelected: null,
				customerSelected: null,

				tasks_statuses: null,
				projects_statuses: null,
				projects: null,
				places: null,
				departments: null,
				users: null,
			}
		},
		mounted() {
			var year = moment().format('YY')
			var month = moment().format('MM')
			var startDate = moment([year, month - 1])
			var endDate = moment()
			this.dataFilter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
			$('#daterange').daterangepicker({
				"startDate": startDate.format('DD/MM/YY'),
				"endDate": endDate.format('DD/MM/YY'),
				"locale": {
					"format": "DD/MM/YY",
					"separator": " - ",
					"applyLabel": "Aceptar",
					"cancelLabel": "Cancelar",
					"fromLabel": "From",
					"toLabel": "To",
					"customRangeLabel": "Custom",
					"daysOfWeek": [
						"Do",
						"Lu",
						"Ma",
						"Mi",
						"Ju",
						"Vi",
						"Sa",
					],
					"monthNames": [
						"Enero",
						"Febrero",
						"Marzo",
						"Abril",
						"Mayo",
						"Junio",
						"Julio",
						"Agosto",
						"Septiembre",
						"Octubre",
						"Noviembre",
						"Diciembre",
					],
					"firstDay": 1
				}
			})
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getTasksStatuses()
				this.getProjectsStatuses()
				this.getProjects()
				this.getDepartments()
			},
			reportTypeSelected() {
				if(this.dataFilter.report_type == 'projects') {
					this.projectSelected = null
				}
				this.clearFilter()
			},
			projectIsSelected() {
				if(this.projectSelected) {
					this.dataFilter.customer_id = null
					this.customerSelected = null
					this.dataFilter.place_id = null
					this.places = this.projectSelected.places
					this.dataFilter.project_id = this.projectSelected.id
				} else {
					this.dataFilter.project_id = null
					this.places = null
				}
			},
			customerIsSelected() {
				if(this.customerSelected) {
					this.dataFilter.customer_id = this.customerSelected.id
				} else {
					this.dataFilter.customer_id = null
					this.dataFilter.place_id = null
				}
			},
			departmentIsSelected() {
				this.dataFilter.user_id = null
				if(this.departmentSelected) {
					this.dataFilter.department_id = this.departmentSelected.id
				} else {
					this.dataFilter.department_id = null
				}
			},
			clearFilter() {
				if(!this.dataFilter.report_type) {
					this.dataFilter.report_type = 'tasks'
				}
				this.dataFilter.task_status_id =  null
				this.dataFilter.project_status_id = null
				this.dataFilter.export = null
				this.dataFilter.customer_id =  null
				//this.dataFilter.project_id = null
				this.dataFilter.place_id = null
				this.places = null
				this.departmentSelected = null
				this.dataFilter.department_id = null
				this.dataFilter.user_id = null

				this.departmentSelected = null
				//this.projectSelected = null
				this.customerSelected = null
			},
			getTasksStatuses: function() {
				this.tasks_statuses = null
				this.$http.get('admin/projects/tasks/statuses')
					.then(response => {
						this.tasks_statuses = response.body
					})
			},
			getProjectsStatuses: function() {
				this.projects_statuses = null
				this.$http.get('admin/projects/projects/statuses')
					.then(response => {
						this.projects_statuses = response.body
					})
			},
			getProjects: function() {
				this.projects = null
				this.dataFilter.project_id = null
				this.$http.get('admin/projects/projects')
					.then(response => {
						this.projects = response.body
					})
			},
			getDepartments() {
				this.departments = null
				this.$http.get('admin/departments/status/2')
					.then(response => {
						this.departments = response.body
					})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/reports/views/Filter.vue